import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: auto;
    height: auto;

    @media (max-width: 769px) {
        width: 100%;
    }
`;

export const CardPlans = styled.div`
    width: 240px;
    height: auto;
    padding: 20px;

    gap: 16px;
    display: flex;
    flex-direction: column;

    cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
    border-radius: 16px;
    border: ${({ selected }) => selected ? "2px solid" : "1px solid"} ${({ selected, disabled }) => selected ? theme.colors.green.Verde_AgroReceita : disabled ? theme.colors.gray.Cinza_11 : theme.colors.gray.Cinza_10};
    background-color: ${({ disabled }) => disabled ? theme.colors.gray.Cinza_11 : theme.colors.white.Branco};

    .radio-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;

        cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
    }

    input[type="radio"] {
        display: none;
    }

    .custom-radio {
        position: relative;

        width: 16px;
        height: 16px;

        display: inline-block;

        cursor: ${({ disabled }) => disabled ? "not-allowed" : "pointer"};
        border-radius: 50%;
        background: ${theme.colors.gray.Cinza_12};
        border: 1px solid ${theme.colors.gray.Cinza_8};;
    }

    input[type="radio"]:checked + .custom-radio {
        border-color: ${theme.colors.green.Verde_AgroReceita};
        background-color: ${theme.colors.green.Verde_AgroReceita};
    }

    input[type="radio"]:checked + .custom-radio::after {
        content: '';
        top: 50%;
        left: 50%;
        position: absolute;

        width: 6px;
        height: 6px;

        background: white;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    @media (max-width: 769px) {
        width: 100%;
    }
`

export const CardPlansHeader = styled.div`
    width: 100%;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
`

export const CardPrice = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    flex-direction: column;
`

export const CardFooter = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    flex-direction: column;

    >p{
        >b{
            font-weight: ${theme.typography.fontWeight.bold};
        }
    }
`